module.exports = __webpack_public_path__ + "img/cend2_en.ebfbfa7.png";